import React, { Component } from "react";
import { observer } from "mobx-react";

import "./index.scss";
import Loading from "@/components/loading";
import Option from "./option";
import Paging from "./paging";
import Ranking from "./ranking";
import Record from "./record";
import Search from "../search";
import Store from "@/stores";

class LadderList extends Component {
	async componentDidMount() {
		const { getOption, getRanking, getRecord } = Store._ladderStore;
		await getOption();
		await getRanking();
		getRecord();
	}
	render() {
		const { option, optionLoading, ranking, rankingLoading, record, recordLoading, targetLoading } = Store._ladderStore; // eslint-disable-line
		if (optionLoading || recordLoading || targetLoading) return <Loading />;
		if (!option || !record) return null;
		return (
			<div className="ladder-list">
				<div className="fl">
					<Option />
					{rankingLoading ? <Loading /> : <Ranking />}
					{!!ranking.length && <Paging />}
				</div>
				<div className="fr">
					<Search />
					<Record />
				</div>
			</div>
		);
	}
}
export default observer(LadderList);